<template>
  <div class="auth-container">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Auth"
};
</script>

<style>
.auth-container {
  width: 100vw;
  height: 100vh;
  background-color: rgb(243, 243, 243);;
  overflow: hidden;
}
</style>